import { IconName } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parse from "html-react-parser";
import { TextElementType } from "../helpers/types";

type Props = {
    value: string;
    classes?: string;
    defaultValue?: string;
    onChange?: (value: string) => void;
    error: string | null;
    autoComplete?: string;
    col?: string;
    startIcon?: string;
    startText?: string;
    showValidation?: boolean;
}

const Input = (props: TextElementType & Props) => {
    const {
        value,
        label,
        type = "text",
        classes,
        name,
        placeholder,
        defaultValue,
        disabled,
        onChange,
        error,
        maxLength,
        autoComplete,
        col,
        startIcon,
        startText,
        showValidation,
        description
    } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.value);
        }
    }

    const validationClass = () => {
        if (disabled || showValidation === false) return '';

        if (value === null || value === undefined) return '';

        if (error) return 'is-invalid';

        return 'is-valid';
    };

    return (
        <div className={col}>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <div className="input-group w-100">
                {startIcon || startText ? (
                    <span className="input-group-text text-uppercase" style={{ backgroundColor: 'var(--bs-secondary-bg)' }}>
                        {startIcon ? (
                            <FontAwesomeIcon icon={["fal", startIcon as IconName]} />
                        ) : (
                            'test'
                        )}
                    </span>
                ) : null}

                <input
                    value={value}
                    type={type}
                    name={name}
                    className={`form-control ${showValidation === false ? '' : !disabled && error && value ? 'is-invalid' : !disabled && value ? 'is-valid' : ''} ${classes}`}
                    /* className={`form-control ${classes} ${validationClass()}`} */
                    onChange={handleChange}
                    defaultValue={defaultValue}
                    placeholder={placeholder}
                    disabled={disabled}
                    maxLength={maxLength ?? 100}
                    autoComplete={autoComplete}
                />
                {validationClass() === 'is-invalid' && error && error !== "hidden" && (
                    <div className="invalid-feedback">{parse(error)}</div>
                )}
            </div>
        </div>
    )
}

export default Input;